module.exports = require('frontend-i18n/lib/I18nProvider');
